import { useEffect, useRef, useState } from 'react';
import { Form, Switch } from 'antd';
import { useIntl } from 'react-intl';
import diff from 'diffObj';

import { NUMBER_TEXT } from 'constants/form';
import { updateBusinessConfigurations } from 'services/business';

import BRButton from 'components/BRButton/BRButton';
import BRFormInputs from 'components/BRFormInputs/BRFormInputs';

import './BostaCreditLimit.less';

const BostaCreditLimit = ({ businessData, submitBusinessUpdate }) => {
  const {
    isRecurrentLimitationForOrderCreation,
    minimumBostaCreditsAmountForOrderCreation
  } = businessData || {};

  const intl = useIntl();
  const formRef = useRef();
  const [form] = Form.useForm();

  const [checked, setChecked] = useState(false);

  const amount = Form.useWatch(
    'minimumBostaCreditsAmountForOrderCreation',
    form
  );

  const onFinish = (values) => {
    const initialData = {
      minimumBostaCreditsAmountForOrderCreation,
      isRecurrentLimitationForOrderCreation
    };
    if (parseInt(amount) === 0) {
      values.isRecurrentLimitationForOrderCreation = false;
    }

    const difference = diff(initialData, values);
    if (!Object.keys(difference).length) {
      return;
    }
    let payload;

    if (
      !Object.keys(difference).includes('isRecurrentLimitationForOrderCreation')
    ) {
      payload = {
        bostaCredits: {
          minimumAmountForOrderCreation:
            values?.minimumBostaCreditsAmountForOrderCreation || 0
        }
      };
    } else {
      payload = {
        bostaCredits: {
          isRecurrentLimitationForOrderCreation:
            values?.isRecurrentLimitationForOrderCreation,
          ...(values.isRecurrentLimitationForOrderCreation === true && {
            minimumAmountForOrderCreation:
              values?.minimumBostaCreditsAmountForOrderCreation
          })
        }
      };
      if (values.isRecurrentLimitationForOrderCreation === false) {
        form.setFieldsValue({
          minimumBostaCreditsAmountForOrderCreation
        });
      }
    }

    submitBusinessUpdate(payload, { callback: updateBusinessConfigurations });
  };

  useEffect(() => {
    form.setFieldsValue({
      minimumBostaCreditsAmountForOrderCreation,
      isRecurrentLimitationForOrderCreation
    });
  }, [minimumBostaCreditsAmountForOrderCreation]);

  useEffect(() => {
    form.setFieldsValue({
      isRecurrentLimitationForOrderCreation
    });
    setChecked(isRecurrentLimitationForOrderCreation);
  }, [isRecurrentLimitationForOrderCreation]);

  const handleChange = (checked) => {
    setChecked(checked);
  };

  return (
    <div className="br-business__bosta-credit-limit">
      <div className="br-business__bosta-credit-limit-form-modal">
        <Form onFinish={onFinish} ref={formRef} form={form}>
          <BRFormInputs
            formRef={formRef}
            name="minimumBostaCreditsAmountForOrderCreation"
            label={intl.formatMessage({
              id: 'businesses.details.manageBusiness.bosta_credit_limits'
            })}
            type={NUMBER_TEXT}
          />

          <Form.Item
            label={intl.formatMessage({
              id: 'businesses.details.manageBusiness.recurring_credits_reset'
            })}
            name="isRecurrentLimitationForOrderCreation"
          >
            <Switch
              checked={checked}
              onChange={handleChange}
              disabled={amount <= 0}
            />
          </Form.Item>

          <BRButton
            type="primary"
            htmlType="submit"
            label={intl.formatMessage({ id: 'common.submit' })}
          />
        </Form>
      </div>
    </div>
  );
};

export default BostaCreditLimit;
